import React, { useState } from 'react';

import * as Accordion from '@radix-ui/react-accordion';

import { ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

const IconPlus = ICONS.PLUS;
const IconMinus = ICONS.MINUS;

const ITEM_VALUE = 'item';

interface ISectionAccordionProps {
  title: string;
  indicatorType?: 'icon' | 'text';
  defaultOpen?: boolean;
  actions?: React.ReactNode;
}

const SectionAccordion: React.FC<ISectionAccordionProps> = ({
  title,
  children,
  indicatorType = 'icon',
  defaultOpen,
  actions,
}) => {
  const { t } = useLocale('checkout');
  const [open, setOpen] = useState(defaultOpen ? ITEM_VALUE : '');

  return (
    <Accordion.Root
      type="single"
      collapsible
      value={open}
      onValueChange={setOpen}
    >
      <S.Item value={ITEM_VALUE}>
        <S.Trigger>
          <h3>{title}</h3>

          <div>
            {actions}

            <div className="indicator">
              {indicatorType === 'icon' ? (
                <>
                  <IconPlus className="closed" />
                  <IconMinus className="open" />
                </>
              ) : (
                <>
                  <span className="closed">{t('Show')}</span>
                  <span className="open">{t('Hide')}</span>
                </>
              )}
            </div>
          </div>
        </S.Trigger>

        <S.Content>{children}</S.Content>
      </S.Item>
    </Accordion.Root>
  );
};

export default SectionAccordion;
